import { isFunction } from "./is.js";
import { hasWindow } from "./has.js";
function nextFrame(callback) {
  const fn = hasWindow() ? window?.requestAnimationFrame ?? setTimeout : setTimeout;
  return new Promise((resolve) => {
    fn((time) => resolve(isFunction(callback) ? callback(time) : time));
  });
}
export {
  nextFrame
};
//# sourceMappingURL=nextFrame.js.map
